/* eslint-disable */
import marked from 'marked'
import ggStore from 'ggApp/modules/store'
import ggTranslator from 'ggApp/modules/translator'
import { createSelector, } from 'reselect'
import objectPath from 'object-path'

export function capitalize(str) {
  return str.replace(/\w\S*/g, function(txt) {return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

export function declOfNum(number, titles) {
  const
    cases = [2, 0, 1, 1, 1, 2,];
  return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}

export function stringNotZero(floatString) {
  return parseFloat(floatString.replace(',', '.')) !== 0
}

export function showDiscount(floatString) {
  return parseFloat(floatString) < 0
    ? floatString.substring(1)
    : floatString
}

export function markdown(html = '') {
    // https://github.com/markedjs/marked/issues/678#issuecomment-156841629
    // Avoid passing to `marked` null value, as well as generally
    // handling falsy values
    if(!html) return '';

    const options = {
        breaks: true,
    }

    return marked(html, options);
}

export function getTranslation(store = {}, key = '') {
  return createSelector(
    ggStore.selectors.storeActive,
    ggTranslator.selectors.keys,
    (storeActive, translations) => {
      const activeStoreLanguage = objectPath.get(storeActive, 'activeLanguage', '')

      return objectPath.get(translations, [activeStoreLanguage, key,], '')
    }
  )(store.getState())
}
